module.exports = __webpack_public_path__ + "img/cut@2x.4047764.webp";